import dataLayer from 'assets/core/js/module/data-layer'

export default function (): void {
  // @NOTE : This is an event for old taggugage, we use dirty solution to limit impact for new solution, this event will be migrated soon normaly
  const els = document.querySelectorAll('[data-download-type="voucher"]')
  dataLayer.pushOnElementClick(window.coreGtmId, els, function (_data, el: Element) {
    return {
      event: dataLayer.events.CUSTOMER_ZONE_VOUCHER_DOWNLOAD,
      czType: getCZType(),
      bookingId: el.getAttribute('data-booking-id'),
    }
  })
}

function getCZType(): string {
  // @ts-expect-error object is defined
  return window.pageDataLayer[window.coreGtmId][0].user_login_status === 'logged in booking' ? 'czLight' : 'czFull'
}
